import React, { useState, useEffect, useContext } from 'react'
import { httprequesthandler } from './httprequesthandler';
// import axios from 'axios';

const AppContext = React.createContext()

var distributor_data = [];

const AppProvider = ({ children }) => {

    const [jsonData, setJsonData] = useState([]);
    const [jsonDataDummy, setJsonDataDummy] = useState([]);
    // const [distributorList, setDistributorList] = useState([]);

    // const [popUp, setPopUp] = useState([]);
    // const [data, setData] = useState();


    const datafetch = () => {
        httprequesthandler('data.json').then(function (data) {
            // console.log(data)
            var menuData;
            //   menuData = data.EN.menus.filter(val => val.menuVisibility !== 'hide')
              menuData = data;
            //   popUpData = data.EN.popupContent.filter(val => val.menuVisibility !== 'hide')
            //    console.log(popUpData)
              return menuData;
            // setJsonData(menuData);
        }).then(function (menuData) {

            // console.log('menuData productTypeList ', menuData)
            window.selectedConfig = {...menuData.onLoadActiveradioButton}
            setJsonData(menuData);

            // setJsonDataDummy(menuData);

            // setPopUp(popUpData);

        }).then(function () {
        //    console.log("the distributor content");
        });
    }

    // console.log("the data inside the jsonData is", jsonData);

    // distributor code commented
    // const distributor = () => {
    //     // console.log('distributor called', jsonData)

    //         // console.log(data)
    //         var menuData;
    //         // return menuData = data.menus.EN.filter(val => val.menuVisibility !== 'hide')
    //         // setJsonData(menuData);

    //         var ldata = data;
    //         // console.log('ldata', ldata[0].distributor);

    //         return menuData = ldata[0].distributor;
    //     }).then(function (menuData) {
    //         // setData(menuData);
    //         setDistributorList(menuData);
    //         distributor_data = menuData;
    //         // console.log("menuData 60",menuData)
    //         // console.log("distributor_data 60",distributor_data)
    //     }).then(function () {
    //         // setTimeout(() => {
    //         // console.log('distributor_updated called', jsonData);
    //         // distributor_updated();
    //         // }, 4000);
    //         // console.log('data', data);
    //     });
    //     // var xhttp = new XMLHttpRequest();
    //     // xhttp.onreadystatechange = function () {
    //     //     if (this.readyState == 4 && this.status == 200) {
    //     //         var ldata = JSON.parse(this.responseText);
    //     //         // var ldata = (this.responseText);
    //     //         // console.log(ldata[0].distributor);
    //     //         // console.log('ldata',ldata.distributor);
    //     //         distributor_data = ldata[0].distributor;
    //     //         setData(ldata[0].distributor)
    //     //         // distributor_updated();
    //     //         console.log("here is the data contained by distributor_data in smith", distributor_data.Smith);
    //     //         console.log("here is the data contained by distributor_data", distributor_data);
    //     //         console.log("here is the data contained by distributor_data in Jones", distributor_data.Jones);
    //     //     }
    //     // };
    //     // xhttp.send();
    // }



    // setTimeout(() => {
    //     DistributorUpdated();
    // }, 2000);



    useEffect(() => {
        if (jsonData.length == 0) {
            datafetch();
        }
        // if (distributorList.length == 0) {
        //     distributor(); // distributor code commented
        // }
    }, [])
    // useEffect(() => {
    //     // distributorUpdated();
    //     // console.log('useEffect distributorUpdated called')
    // }, [jsonDataDummy, distributorList])

    // const [jsonData, setJsonData] = useState([]);
    // const [distributorList, setDistributorList] = useState([]);
    // console.log('jsonData AppContext', jsonData);
    return (
        <AppContext.Provider
            value={{
                jsonData
            }}>
            { jsonData.length != 0 && children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext)
}

export { AppContext, AppProvider }